import { useState } from "react";
import { DialogContent, DialogTitle, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import { useDispatch } from "react-redux";
import MDDialog from "components/MDDialog";
import MDSnackbar from "components/MDSnackbar";
import { Formik } from "formik";
import { useMaterialUIController } from "context";
import CircularIndeterminate from "components/MDLoading";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import { updateLicensePlate } from "store/slice/reservation/reservationSlice";
import CustomTooltip from "components/Common/CustomTooltip";

const LicensePlateUpdate = (props) => {
  const dispatch = useDispatch();
  const { dialogOpen, onClose, data, getReservationsData } = props;
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(false);
  const [openTooltipId, setOpenTooltipId] = useState(null);

  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });

  console.log("data ====>", data);

  const handelUpdateLicensePlate = async (payload) => {
    console.log("payload ---->", payload);
    setIsLoading(true);
    await dispatch(updateLicensePlate(payload))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        if (success) {
          getReservationsData();
          setIsLoading(false);
          onClose();
        }
        setIsLoading(false);
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        // onClose();
      })
      .catch((err) => {
        console.error("Error getting cancel:", err);
      });
  };

  return (
    <>
      <CircularIndeterminate
        type="full"
        size={20}
        text="Updating License Plate..."
        open={isLoading}
      />
      <MDSnackbar
        color={notification.color}
        icon={notification.icon}
        title={notification.title}
        content={notification.content}
        open={notification.show}
        close={notification.close}
        bgWhite
      />
      <MDDialog
        dialogTitle={
          <MDBox display="flex" alignItems="center" gap={1}>
            <span>License Plate Update</span>
            <CustomTooltip
              id="licensePlateUpdate"
              title={`First, adjust the License Plate below and press UPDATE.
After updating, the Customer will receive a new confirmation message and receipt
reflecting the updated license plate. This updated license plate will also be passed
to any integrated 3rd party vendors.`}
              openTooltipId={openTooltipId}
              setOpenTooltipId={setOpenTooltipId}
            />
          </MDBox>
        }
        open={dialogOpen}
        dialogClose={onClose}
        closeIcon={true}
        maxWidth="sm"
      >
        {/* <DialogTitle sx={{ "&.MuiDialogTitle-root": { pb: "0px !important" } }}>
          <MDBox display="flex" alignItems="center" gap={1}>
            <span>License Plate Update</span>
            <CustomTooltip
              id="licensePlateUpdate"
              title="First, adjust the License Plate below and press UPDATE. After updating, the Customer
will recieve a new confirmation message and receipt reflecting the updated license
plate. This updated license plate will also be passed to any integrated 3rd party
vendors.
"
              openTooltipId={openTooltipId}
              setOpenTooltipId={setOpenTooltipId}
            />
          </MDBox>
        </DialogTitle> */}
        <DialogContent>
          <Formik
            initialValues={{
              reservationId: data?.reservationId || "",
              licensePlate: data?.licensePlate?.[0] || "",
              purpose: "PARKING",
            }}
            onSubmit={(value, action) => {
              const payload = {
                ...value,
                licensePlate: [value.licensePlate],
              };
              handelUpdateLicensePlate(payload);
            }}
          >
            {(props) => (
              <form onSubmit={props.handleSubmit}>
                <Grid container spacing={2} className="mt-1">
                  {!props.values.fullRefund && (
                    <>
                      <Grid item xs={12}>
                        <MDInput
                          label="License Plate Number"
                          name="licensePlate"
                          value={props.values.licensePlate}
                          onChange={props.handleChange}
                          error={
                            props.errors.licensePlate &&
                            props.touched.licensePlate
                              ? true
                              : false
                          }
                          success={
                            props.errors.licensePlate &&
                            props.touched.licensePlate
                              ? false
                              : true
                          }
                          helperText={
                            props.errors.licensePlate &&
                            props.touched.licensePlate
                              ? props.errors.licensePlate
                              : null
                          }
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <MDBox display="flex" justifyContent="end" gap={2}>
                      <MDButton
                        color="danger"
                        variant="contained"
                        onClick={onClose}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        color={sidenavColor}
                        variant="contained"
                        type="submit"
                      >
                        Update
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </MDDialog>
    </>
  );
};

export default LicensePlateUpdate;
